module.exports = __webpack_public_path__ + "static/9-cc674e3f029e9daaa2f4e69e92462ad3.png";